module.exports = __webpack_public_path__ + "img/9.041566e1.png";